import * as React from 'react'

const toKebabCase = string => string.replace(/([a-z0-9]|(?=[A-Z]))([A-Z])/g, '$1-$2').toLowerCase()

// Used to save reference to active listeners
const listeners = Symbol('jsx-native-events/event-listeners')

const eventPattern = /^_on[A-Z]/

export default function jsx (type, props, ...children) {
  const newProps = { ...props }
  if (typeof type === 'string') {
    newProps.ref = (element) => {
      // merge existing ref prop
      if (props && props.ref) {
        if (typeof props.ref === 'function') {
          props.ref(element)
        } else if (typeof props.ref === 'object') {
          props.ref.current = element
        }
      }

      if (element) {
        if (props) {
          const keys = Object.keys(props)
          /** Get all keys that have the `_on[A-Z]` prefix */
          keys
            .filter(key => key.match(eventPattern))
            .map(key =>
              ({
                key,
                eventName: toKebabCase(
                  key.slice(3)
                ).replace('-', '')
              })
            )
            .map(({ eventName, key }) => {
              /** Add the listeners Map if not present */
              if (!element[listeners]) {
                element[listeners] = new Map()
              }
  
              /** If the listener hasn't be attached, attach it */
              if (!element[listeners].has(eventName)) {
                element.addEventListener(eventName, props[key])
                /** Save a reference to avoid listening to the same value twice */
                element[listeners].set(eventName, props[key])
              }
            })
        }
      }
  }
  }
  
  return React.createElement.apply(null, [type, newProps, ...children])
}
